import { ShippingFlowSelectorOptionsEnum } from '../../../constants/addressBook';
import { ICommonAddress } from '../../../types/shipping';
import { IState } from './reducer';

export enum ActionTypesEnum {
  changeSelect = 'changeSelect',
  changeAB = 'changeAB',
  changeFixedAddress = 'changeFixedAddress',
  changeOfficeDropship = 'changeOfficeDropship',
  reset = 'reset',
}

export interface IAction<T = undefined> {
  type: ActionTypesEnum;
  payload: T;
  metadata?: any;
}

type TChangeSelectAction = IAction<ShippingFlowSelectorOptionsEnum> & { type: ActionTypesEnum.changeSelect };
type TChangeABAction = IAction<string[]> & { type: ActionTypesEnum.changeAB };
type TChangeFixedAddressAction = IAction<ICommonAddress> & { type: ActionTypesEnum.changeFixedAddress };
type TChangeOfficeDropshipAction = IAction<boolean> & { type: ActionTypesEnum.changeOfficeDropship };
type TResetAction = IAction<IState> & { type: ActionTypesEnum.reset; payload: IState };

export type TAction =
  | TChangeSelectAction
  | TChangeABAction
  | TChangeFixedAddressAction
  | TChangeOfficeDropshipAction
  | TResetAction;

export const changeSelect = (payload: ShippingFlowSelectorOptionsEnum): TChangeSelectAction => ({
  type: ActionTypesEnum.changeSelect,
  payload,
});

export const changeAB = (payload: string[]): TChangeABAction => ({
  type: ActionTypesEnum.changeAB,
  payload,
});

export const changeFixedAddress = (payload: ICommonAddress): TChangeFixedAddressAction => ({
  type: ActionTypesEnum.changeFixedAddress,
  payload,
});

export const changeOfficeDropship = (payload: boolean): TChangeOfficeDropshipAction => ({
  type: ActionTypesEnum.changeOfficeDropship,
  payload,
});

export const reset = (initialState: IState): TResetAction => ({
  type: ActionTypesEnum.reset,
  payload: initialState,
});
